import './Toast.css'

export interface ToastProps {
  message: string
}

/** One notice. It carries no live role of its own: ToastHost's region announces it. */
export function Toast({ message }: ToastProps) {
  return <div className="toast">{message}</div>
}
